'use client'

import { X } from 'lucide-react'
import { CommunityInviteRecipientSummary } from '@/components/community-invite-recipient-summary'
import type { ContactOrUser, ShareRoomGuestInviteRow } from '@/components/share-room/types'

export type ShareRoomCommunityStepReviewSectionProps = {
  selectedContactsAndUsers: ContactOrUser[]
  onRemoveSelected: (id: string) => void
  guestInviteRows: ShareRoomGuestInviteRow[]
  onRemoveGuestEmail: (email: string) => void
}

export function ShareRoomCommunityStepReviewSection({
  selectedContactsAndUsers,
  onRemoveSelected,
  guestInviteRows,
  onRemoveGuestEmail,
}: ShareRoomCommunityStepReviewSectionProps) {
  return (
    <div className="space-y-4">
      <CommunityInviteRecipientSummary recipients={selectedContactsAndUsers} onRemove={onRemoveSelected} />
      {guestInviteRows.length > 0 && (
        <div className="rounded-lg border border-slate-200 bg-slate-50/90 p-3">
          <p className="mb-2 text-sm font-medium text-slate-800">
            {guestInviteRows.length} {guestInviteRows.length === 1 ? 'address' : 'addresses'} from email list
          </p>
          <div className="flex flex-wrap gap-2">
            {guestInviteRows.map((r) => (
              <div
                key={r.email}
                className="inline-flex max-w-full items-center gap-1 rounded-full bg-white px-2 py-1 text-xs text-slate-800 shadow-sm"
              >
                <span className="truncate">{r.email}</span>
                <button
                  type="button"
                  className="rounded-full p-0.5 text-slate-500 hover:bg-slate-100"
                  aria-label={`Remove ${r.email}`}
                  onClick={() => onRemoveGuestEmail(r.email)}
                >
                  <X className="h-3 w-3" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
